export default function PHP_AjaxPoll() {
  return (
    <div>
      <h1>PHP_AjaxPoll</h1>
    </div>
  );
}
